import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Pagination,
  Box,
} from "@mui/material";
import { convertBase64ToFileAndView } from "../../helpers/Base64ToFile";
import { showToast } from "../../helpers/ToastifyHelper";
import { useNavigate } from "react-router";
import { displayValue } from "../../helpers/TodayDate";
import { ThemeContext } from "../../context/themeProviderContext";

interface Column {
  header: string;
  field: string;
  className?: string;
  beyan?: number;
  exportfileName?: string;
  style?: string;
  classNameDiv?: string;
}

interface Row {
  [key: string]: any;
}

interface TableProps {
  columns: Column[];
  data: Row[];
  recordsPerPage?: number;
  borcKontrol?: (sqId: number, value: number, turu?: string) => void;
  handleClick?: (index: number) => void;
  printRapor?: (
    odemeTarihi: Date,
    vezneKodu: number,
    seriNo: string,
    makbuzNo: number
  ) => void;
  getTahsilatBilgileriGet?: (
    odemeTarihi: string,
    vezneKodu: number,
    seriNo: string,
    makbuzNo: number
  ) => Promise<void>;
  printRaporEndeks?: (isYadaAboneNo: number) => void;
  printRaporBordro?: (sqId: string, kadroTuruId: any) => void;
  isSearched?: boolean;
}

const TableComponent2: React.FC<TableProps> = ({
  columns,
  data,
  recordsPerPage = 5,
  borcKontrol,
  printRapor,
  getTahsilatBilgileriGet,
  printRaporEndeks,
  printRaporBordro,
  isSearched = true,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentRecords, setCurrentRecords] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);

  const themeContext = useContext(ThemeContext);
  const ilMi = themeContext?.ilMi || "H"; // H = İlçe (Rayiç Göster), E = İl/Büyükşehir (Rayiç Gizle)

  useEffect(() => {
    const pages = Math.ceil(data.length / recordsPerPage);
    setTotalPages(pages);
  }, [data, recordsPerPage]);

  useEffect(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    setCurrentRecords(data.slice(indexOfFirstRecord, indexOfLastRecord));
    console.log(data);
  }, [currentPage, data, recordsPerPage]);

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const navigate = useNavigate();

  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <TableContainer component={Paper}>
        <Table className="border" size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  style={{ verticalAlign: "middle",borderRight: "1px solid #ddd", }}
                  className={`text-center ${column.className}`}
                >
                  {column.header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentRecords.length !== 0 ? (
              currentRecords.map((item, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((column, colIndex) => {
                    switch (column.beyan) {
                      case 1:
                        return (
                          <TableCell
                            style={{
                              verticalAlign: "middle",
                              fontSize: "1rem",
                              padding: "0.5rem",
                              borderRight: "1px solid #ddd",
                            }}
                            className={column.className}
                            key={colIndex}
                          >
                            <div className={column.classNameDiv}>
                              <Button
                               
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  borcKontrol ? borcKontrol(item.sqId, 1) : ""
                                }
                                size="small"
                              >
                                Beyan Sureti
                              </Button>
                            </div>
                          </TableCell>
                        );
                      case 2:
                        return (
                          <TableCell
                            style={{
                              verticalAlign: "middle",
                              fontSize: "1rem",
                              padding: "0.5rem",
                              borderRight: "1px solid #ddd",
                            }}
                            className={column.className}
                            key={colIndex}
                          >
                            <div className={column.classNameDiv}>
                              <Button
                               
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  borcKontrol ? borcKontrol(item.sqId, 1) : ""
                                }
                                size="small"
                              >
                                Beyan Sureti
                              </Button>
                              {/* <Button
                                sx={{ px: 0.2, py: 0 }}
                                variant="contained"
                                color="primary"
                                onClick={() => navigate("/tahsilat")}
                                size="small"
                              >
                                Öde
                              </Button> */}
                            </div>
                          </TableCell>
                        );
                      case 3:
                        return (
                          <TableCell
                            style={{
                              verticalAlign: "middle",
                              fontSize: "1rem",
                              padding: "0.5rem",
                              borderRight: "1px solid #ddd",
                            }}
                            className={column.className}
                            key={colIndex}
                          >
                            <div className={column.classNameDiv}>
                              {/* <Button
                                sx={{ px: 0.2, py: 0.4 }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  if (borcKontrol) {
                                    borcKontrol(item.sqId, 1, item.turu);
                                  }
                                }}
                                disabled={item.satisTarihi != undefined}
                                size="small"
                              >
                                Suret
                              </Button> */}
                              {ilMi !== "E" && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    if (borcKontrol) {
                                      borcKontrol(item.sqId, 2, item.turu);
                                    }
                                  }}
                                  size="small"
                                >
                                  Rayiç
                                </Button>
                              )}
                             {/*  <Button
                                sx={{ px: 0.2, py: 0.4 }}
                                variant="contained"
                                color="primary"
                                onClick={() => navigate("/tahsilat")}
                                size="small"
                              >
                                Öde
                              </Button> */}
                            </div>
                          </TableCell>
                        );
                      case 4: //Online Odeme Bilgileri
                        return (
                          <TableCell
                            style={{
                              verticalAlign: "middle",
                              fontSize: "1rem",
                              padding: "0.5rem",
                              borderRight: "1px solid #ddd",
                            }}
                            className={column.className}
                            key={colIndex}
                          >
                            <div className={column.classNameDiv}>
                              <Button
                                sx={{ px: 0.2, py: 0.8 }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  if (getTahsilatBilgileriGet) {
                                    getTahsilatBilgileriGet(
                                      item.odemeTarihi,
                                      item.vezneKodu,
                                      item.seriNo,
                                      item.makbuzNo
                                    );
                                  }
                                }}
                                size="small"
                              >
                                <i
                                  style={{ fontSize: "1.3rem" }}
                                  className="fa fa-search"
                                />
                              </Button>
                              <Button
                                sx={{ px: 0.2, py: 0.8 }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  if (printRapor) {
                                    printRapor(
                                      item.odemeTarihi,
                                      item.vezneKodu,
                                      item.seriNo,
                                      item.makbuzNo
                                    );
                                  }
                                }}
                                size="small"
                              >
                                <i
                                  style={{ fontSize: "1.2rem" }}
                                  className="icofont icofont-printer"
                                />
                              </Button>
                            </div>
                          </TableCell>
                        );
                      case 5: //Online Odeme Bilgileri
                        return (
                          <TableCell
                            style={{
                              verticalAlign: "middle",
                              fontSize: "1rem",
                              padding: "0.5rem",
                              borderRight: "1px solid #ddd",
                            }}
                            className={column.className}
                            key={colIndex}
                          >
                            <div className={column.classNameDiv}>
                              <Button
                                sx={{ px: 0.2, py: 0.8 }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  if (printRaporEndeks) {
                                    printRaporEndeks(item.aboneNo);
                                  }
                                }}
                                size="small"
                              >
                                <i
                                  style={{ fontSize: "1.2rem" }}
                                  className="icofont icofont-printer"
                                />
                              </Button>
                            </div>
                          </TableCell>
                        );
                      case 6: //EBordro
                        return (
                          <TableCell
                            style={{
                              verticalAlign: "middle",
                              fontSize: "1rem",
                              padding: "0.5rem",
                              borderRight: "1px solid #ddd",
                            }}
                            className={column.className}
                            key={colIndex}
                          >
                            
                              <Button
                                sx={{ px: 0.2 }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  if (printRaporBordro) {
                                    printRaporBordro(
                                      item.sqId.toString(),
                                      Number(item.kadroTuruId)
                                    );
                                  }
                                }}
                                size="small"
                              >
                                <i className="icofont icofont-printer" />
                              </Button>
                          </TableCell>
                        );
                      default:
                        return (
                          <TableCell
                            style={{
                              verticalAlign: "middle",
                              fontSize: "0.95rem",
                              borderRight: "1px solid #ddd",
                            }}
                            className={column.className}
                            key={colIndex}
                          >
                            {displayValue(item[column.field])}
                          </TableCell>
                        );
                    }
                  })}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  style={{
                    fontSize: "1.0rem",
                    padding: "0.5rem",
                    borderRight: "1px solid #ddd",
                    verticalAlign: "middle",
                  }}
                  colSpan={columns.length}
                >
                  {isSearched ? "Kayıt Bulunamadı." : "Lütfen Arama Yapınız."}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={2} display="flex" justifyContent="center">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
        />
      </Box>
    </div>
  );
};

export default TableComponent2;
